import i18next, { type TFunction } from "i18next";

type AmalYozuvi = readonly [action: string, i18nKey: string];

/**
 * ⚠️ Mapping OBYEKT LITERALI emas, juftliklar massivi: `set_photo` va
 * `reset_password` kabi kalitlar backend yozadigan AYNAN o'sha satrlar va
 * ular obyekt kaliti bo'lganda Biome `useNamingConvention` bilan
 * ogohlantiradi. Kalitni camelCase ga «tuzatish» esa mappingni jimgina
 * ishlamas holga keltirardi.
 *
 * ⚠️ Ikkinchi ustun endi TAYYOR MATN emas, `audit.json` dagi i18n KALITI
 * (P7 spec §8). `keySeparator: "."` sababli `users.password_changed` kabi
 * NUQTALI amal nomini JSON kalit sifatida ishlatib bo'lmaydi — u nested
 * yo'l sifatida talqin qilinardi. Shuning uchun kalit nomi (masalan
 * `actions.domain.usersPasswordChanged`) amal nomidan MUSTAQIL.
 */
const HTTP_AMALLARI: readonly AmalYozuvi[] = [
	["create", "actions.create"],
	["update", "actions.update"],
	["delete", "actions.delete"],
	["approve", "actions.approve"],
	["reject", "actions.reject"],
	["cancel", "actions.cancel"],
	["archive", "actions.archive"],
	["assign", "actions.assign"],
	["unassign", "actions.unassign"],
	["end_assignment", "actions.endAssignment"],
	["revoke", "actions.revoke"],
	["move", "actions.move"],
	["publish", "actions.publish"],
	["retry", "actions.retry"],
	["export", "actions.export"],
	["correct", "actions.correct"],
	["deactivate", "actions.deactivate"],
	["set_photo", "actions.setPhoto"],
	["delete_photo", "actions.deletePhoto"],
	["reset_password", "actions.resetPassword"],
	["risk_acknowledge", "actions.riskAcknowledge"],
	["confirm", "actions.confirm"],
	["read", "actions.read"],
	["list", "actions.list"],
];

/**
 * ⚠️⚠️ **Meros DOMEN amallari** (kontrakt §4.4). `audit_log` da IKKI amal
 * lug'ati bor va bu ATAYLAB:
 *
 * | Qatlam | Kim yozadi | `action` shakli |
 * |---|---|---|
 * | HTTP | `auditMiddleware` | `create` · `update` · `reset_password` … |
 * | Domen | repozitoriyning o'zi | `users.password_changed` · `employees.archive` … |
 *
 * Ular birlashtirilmagan: meros yozuvlari `before`/`reason` bilan boyroq
 * va `attendance.corrected` mutatsiya bilan BIR TRANZAKSIYADA yoziladi.
 * Mapping IKKALASINI ham qamraydi — aks holda jadvalda xom
 * `users.password_changed` turardi.
 */
const DOMEN_AMALLARI: readonly AmalYozuvi[] = [
	["users.password_changed", "actions.domain.usersPasswordChanged"],
	["users.reset_password", "actions.domain.usersResetPassword"],
	["employees.archive", "actions.domain.employeesArchive"],
	["attendance.corrected", "actions.domain.attendanceCorrected"],
	/**
	 * ⚠️ **Bu yozuv «meros» emas** — u ochiq `/delete-account` sahifasidan
	 * keladi (`POST /account-deletion-requests`). Baribir DOMEN amallari
	 * guruhida, chunki qatorni middleware emas, repozitoriyning o'zi
	 * yozadi: marshrutda `authMiddleware` yo'q, ya'ni middleware aktyorni
	 * aniqlay olmasdi.
	 *
	 * ⚠️ Bu yozuvsiz jadvalda xom `account_deletion.requested` turardi va
	 * filtr ro'yxatida u UMUMAN ko'rinmasdi — ya'ni «so'rovni odam
	 * ko'radi» degan butun asos jimgina yiqilardi.
	 */
	["account_deletion.requested", "actions.domain.accountDeletionRequested"],
];

/**
 * ⚠️ Ro'yxat marshrutlarning HAQIQIY metadatasidan olingan
 * (`grep 'audit: {' apps/backend/src/routes`), rejadagi taxminiy
 * ro'yxatdan emas: reja `resetPassword` deb yozgan edi, marshrut esa
 * `reset_password` yozadi va camelCase kalit hech qachon mos kelmasdi.
 */
const AMAL_KALITLARI: Record<string, string> = Object.fromEntries([
	...HTTP_AMALLARI,
	...DOMEN_AMALLARI,
]);

/**
 * ⚠️ Noma'lum amal uchun XOM qiymat qaytariladi — keyingi bosqichlar yangi
 * amal qo'shganda jadvalda bo'sh katak emas, o'qib bo'ladigan xom satr
 * turishi kerak.
 *
 * ⚠️ **`t` IXTIYORIY — orqaga qarab MOSLIK uchun.** `@/modules/employees`
 * ning `EmployeeAuditTab.tsx` i (P7 §8 doirasidan TASHQARIDA, tahrirlash
 * taqiqlangan) bu funksiyani BITTA argument bilan chaqiradi. `t`
 * berilmasa, global `i18next` singletonining joriy tilidan "audit"
 * namespace'i olinadi (`index.ts` uni `main.tsx`da ALLAQACHON ishga
 * tushirgan bo'ladi) — chaqiruvchini o'zgartirmasdan xatti-harakat bir
 * xil qoladi.
 */
export function amalNomi(
	action: string,
	t: TFunction<"audit"> = i18next.getFixedT(null, "audit")
): string {
	const key = AMAL_KALITLARI[action];

	return key ? t(key) : action;
}

function options(yozuvlar: readonly AmalYozuvi[], t: TFunction<"audit">) {
	return yozuvlar.map(([value, key]) => ({ value, label: t(key) }));
}

/**
 * Filtr `Select`ining opsiyalari — IKKI GURUH.
 *
 * ⚠️ Guruhlar ATAYLAB ajratilgan: `reset_password` (HTTP) va
 * `users.reset_password` (domen) bir xil yorliqqa ega, yagona ro'yxatda
 * ular farqlanmasdi va foydalanuvchi qaysi birini tanlaganini bilmasdi.
 */
export function amalGuruhlari(t: TFunction<"audit">) {
	return [
		{ label: t("filters.actionGroups.http"), options: options(HTTP_AMALLARI, t) },
		{ label: t("filters.actionGroups.domain"), options: options(DOMEN_AMALLARI, t) },
	];
}

/**
 * Resurs turlari — STATIK ro'yxat.
 *
 * ⚠️ Audit jurnalidan `DISTINCT` so'rash 100k qatorli jadvalda sekin
 * bo'lardi va filtr paneli sahifa ochilishini kechiktirardi.
 *
 * ⚠️⚠️ **`attendance_days` ro'yxatda YO'Q.** Kontrakt §4.4 ning oxirgi
 * jadvali `attendance.corrected` ni `attendance_days` deb ko'rsatadi,
 * lekin u ESKIRGAN: 4-bosqich Task 7 da repozitoriy kanonik
 * `"attendance"` yozadigan qilib tuzatilgan (`audit.schemas.ts` dagi
 * izoh ham shunday deydi). Eski nomni qoldirish doim nol qator
 * qaytaradigan filtr opsiyasini berardi.
 *
 * ⚠️ `auth` ham YO'Q — kirish marshrutlarida audit metadatasi umuman
 * yo'q, ya'ni bu tur hech qachon yozilmaydi.
 *
 * ⚠️ `reports` va `retention` esa OLDINGA qarab qo'yilgan: ular H va K
 * bloklari merge qilinishini kutadi va shu paytgacha nol qator
 * qaytaradi. `auth` dan farqi shundaki, `auth` HECH QACHON yozilmaydi,
 * bular esa yozila boshlaydi — o'chirib qo'yish merge tartibiga tuzoq
 * qo'yardi (kimdir keyin qayta qo'shishni eslashi kerak bo'lardi).
 *
 * ⚠️ Bu qiymatlar TARJIMA QILINMAYDI — resurs identifikatorlari
 * (`positions`, `zones`, ...), ko'rinadigan prosaik matn emas.
 */
export const RESURS_TURLARI = [
	"absences",
	"attendance",
	"departments",
	"devices",
	"employees",
	"files",
	"holidays",
	"jobs",
	"lead-forms",
	"leads",
	"positions",
	"reports",
	"retention",
	"role-assignments",
	"roles",
	"schedules",
	"settings",
	"sync",
	"tasks",
	"users",
	"zones",
];
